






































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { VForm } from "@/types/vuetify/vForm";

@Component({ components: {} })
export default class FormDialog extends Vue {
  @Prop() private showDialog!: boolean;
  @Prop() private isNew?: boolean;
  @Prop({ default: "" }) private title?: string;
  @Prop({ default: "保存" }) private okLabel?: string;
  @Prop({ default: "キャンセル" }) private cancelLabel?: string;
  @Prop({ default: "必須項目を入力してください" })
  private validationMessage?: string;

  readyToSave = false;

  @Ref() readonly formSave!: VForm;

  ok() {
    if (this.formSave) this.formSave.resetValidation();
    this.$emit("ok");
  }
  cancel() {
    if (this.formSave) this.formSave.resetValidation();
    this.$emit("cancel");
  }
  get dialog() {
    return this.showDialog;
  }
  set dialog(value) {
    this.$emit("update:showDialog", value);
  }
}
